import { useEffect, useState } from "react";
// @mui
import {
	Button,
	Typography,
	Box,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogContentText,
	DialogActions,
} from "@mui/material";

// ----------------------------------------------------------------------

const dateFormat = "YYYY-MM-DD HH:mm:ss";

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box sx={{ p: 1, paddingTop: 3 }}>
					<Typography>{children}</Typography>
				</Box>
			)}
		</div>
	);
}
const defaultState = null;
export default function UploadFileDialog(props) {
	const [file, setFile] = useState(defaultState);
	const onSuccess = () => {
		setFile(defaultState);
		props.onSuccessHandler(file);
	};
	const onCancel = () => {
		setFile(defaultState);
		props.onClose();
	};
	return (
		<>
			<Dialog
				open={props.open}
				onClose={() => {}}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">Upload Credits</DialogTitle>
				<DialogContent>
					<Box sx={{ width: "300px", display:'flex', justifyContent:'space-between', alignItems:'center' }}>

						<Button variant="contained" component="label">
							Upload File
							<input hidden multiple type="file" onChange={(e)=>{setFile(e.target.files[0])}} />
						</Button>
						<span>{file && file.name}</span>

					</Box>

					<Box sx={{ width: "100%" }}></Box>
				</DialogContent>
				<DialogActions>
					<Button onClick={() => onCancel()}>Cancel</Button>
					<Button onClick={() => onSuccess()} autoFocus>
						Save
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
}
